export default "__VITE_ASSET__zCGPBuNo__"